import { useEffect, useState } from 'react';
import { api, tokenStore, type MonthlyReport } from '../api-client';

export default function Reports() {
  const [reports, setReports] = useState<MonthlyReport[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!tokenStore.get()) {
      window.location.href = '/login';
      return;
    }
    api
      .listReports()
      .then((r) => setReports(r.reports))
      .catch((e) => setError((e as Error).message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-slate-500">読み込み中…</p>;
  if (error) return <p className="text-red-600">エラー: {error}</p>;

  return (
    <div>
      <h2 className="text-2xl font-bold mb-2">月次レポート</h2>
      <p className="text-sm text-slate-500 mb-6">
        毎月1日に自動配信されます（メール宛先はテナント設定）
      </p>

      <div className="bg-white rounded-lg shadow border">
        {reports.length === 0 ? (
          <p className="p-5 text-slate-500 text-sm">まだ月次レポートがありません。</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-100 text-left">
              <tr>
                <th className="px-4 py-3">対象月</th>
                <th className="px-4 py-3">処理件数</th>
                <th className="px-4 py-3">成功</th>
                <th className="px-4 py-3">失敗</th>
                <th className="px-4 py-3">配信</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((r) => (
                <tr key={r.id} className="border-t">
                  <td className="px-4 py-3 font-medium">{r.year_month}</td>
                  <td className="px-4 py-3">{r.total_jobs}件</td>
                  <td className="px-4 py-3 text-green-700">{r.success_jobs}件</td>
                  <td className="px-4 py-3 text-red-700">{r.failed_jobs}件</td>
                  <td className="px-4 py-3 text-xs text-slate-500">
                    {r.sent_at
                      ? new Date(r.sent_at).toLocaleDateString('ja-JP')
                      : '未配信'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
